module.exports = __webpack_public_path__ + "img/symbol_6.d7a1f69d.png";